import { WordPress } from "../../../../wordpress/wordpress_api";
import { CMSState, Link as LinkType } from "../../../../cms/blocks/types.gen";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { IOWidget, Action, mk_widget } from "widgets-for-react";
import { PublicSiteState } from "../../../../public_site.main.mod";
import React from "react";
import { link, linkWrapper, isLinkExternal, isLinkDownload } from "../../../../cms/blocks/utils.gen";
import { decodeHTMLEntities, toRelativeUrl } from "../../../../../helpers";
import { ButtonData } from "../../../../wordpress/types_and_parser/extra_types.mod";
import { getImageAttribute } from "../../../utils/extra_images.mod";
import { Link } from "react-router-dom";

export type GridBlockItem = {
    title: string
    intro: string
    image?: WordPress.MediaResponse
    link?: LinkType
}

export type GridAttributes = {
    blockName: 'vidda/grid'
    title: string
    intro: string
    primary_button?: ButtonData
    secondary_button?: ButtonData
    blocks: Array<GridBlockItem>
}

export interface GridInterface {
    blockName: 'vidda/grid'
    attrs: GridAttributes
}

export type GridBlockProps<extra_images> = GridAttributes

export type GridBlockStyle = Partial<{
    block_classname: string
    inner_classname: string
    header_classname: string
    title_classname: string
    content_classname: string
    intro_classname: string
    visual_classname: string
}>

export function GridBlock<customBlockData, extra_images>(
    props: GridBlockProps<extra_images>,
    options?: { style: GridBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
    return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
        return mk_widget({
            run: _ => (
              <section className={`block block--grid block--grid--${props.blocks[0].image ? 'image' : 'text'}`}>
                <div className="block__inner container container--m gutter--m spacing--m">
                  {(props.title || props.intro) && <header className="block__header block__header--spacing block__header--columns">
                    {props.title && <h2 className="block__title typo--l ff--primary ls-second-item">{decodeHTMLEntities(props.title)}</h2>}
                    {props.intro && (<p className="block__intro ls-first-item" dangerouslySetInnerHTML={{ __html: props.intro }}></p>)}
                  </header>}
                  <div className="block__content">
                    <ul className={`block__grid grid ls-columns${props.blocks[0].image ? '' : '-xl'}`}>
                    {props.blocks.map(grid => {
                      const gridItemInner: JSX.Element = <>
                        <div className="grid__content ls-bottom-item">
                          {grid.title && <h3 className="grid__title typo--ml ff--primary ls-second-item">{decodeHTMLEntities(grid.title)}</h3>}
                          {grid.image && grid.intro ? 
                            <p className="grid__intro">{decodeHTMLEntities(grid.intro)}</p> 
                            : (grid.intro && <p className="grid__intro">{decodeHTMLEntities(grid.intro)}</p>)}
                          {props.blocks[0].image && grid.link && <div className="grid__fauxlink fauxlink">
                            <div className="fauxlink__inner">
                              <span className="fauxlink__copy">{decodeHTMLEntities(grid.link.title)}</span>
                              <svg className="fauxlink__icon" height="14" width="16" aria-hidden="true"><use xlinkHref="#arrow"/></svg>
                            </div>
                          </div>}
                        </div>
                        {grid.image && 
                          <div className="grid__visual">
                            <img
                              className="grid__image lazyload"
                              src='/frontend/images/empty.png'
                              width={getImageAttribute(grid.image, 'grid-s', 'width')}
                              height={getImageAttribute(grid.image, 'grid-s', 'height')}
                              alt={grid.image.alt_text ? grid.image.alt_text : ''}
                              data-sizes="auto"
                              data-src={getImageAttribute(grid.image, 'grid-s', 'source_url')}
                              data-srcset={`${getImageAttribute(grid.image, 'grid-s', 'source_url')} 440w,
                              ${getImageAttribute(grid.image, 'grid-m', 'source_url')} 880w,
                              ${getImageAttribute(grid.image, 'grid-l', 'source_url')} 1540w`}
                            />
                          </div>
                        }
                      </>

                      return <li className={`grid__item grid__item--${grid.image ? 'image' : 'text'} ls-item`}>
                        {grid.link ?
                          link(grid.link, { classname: `grid__link grid__inner${grid.image ? ' ls-reversed border-radius--s' : ''}` }, gridItemInner)
                          :
                          <div className={`grid__inner${grid.image ? ' ls-reversed border-radius--s' : ''}`}>{gridItemInner}</div>
                        }
                      </li>
                    })}
                    </ul>
                    
                  </div>
                  {(props.primary_button || props.secondary_button) && (
                    <footer className="block__footer ls-clickables">
                    {props.primary_button && (
                      link(linkWrapper({title:props.primary_button.text,url:props.primary_button.url}),
                      { classname: 'button button--primary ls-clickable' },
                      props.primary_button.text
                      )
                    )}
                    {props.secondary_button && (
                      link(linkWrapper({title:props.secondary_button.text,url:props.secondary_button.url}),
                      { classname: 'button button--secondary ls-clickable' },
                      props.secondary_button.text
                      )
                    )}
                    </footer>
                  )}
                  </div>
              </section>
            )
        })
    }
}